import ExpensesTable from 'pages/expenses/ExpensesTable';

interface Props {
    contactId?: string;
}

const InvoiceView: React.FC<Props> = ({ contactId }) => {
    if (!contactId || isNaN(Number(contactId))) {
        return null;
    }

    return (
        <div className="flex h-full flex-col gap-4">
            <ExpensesTable
                passiveFilter={`matter.clientParty.id==${contactId}`}
                disabledFilterIds={['expenseClientFilter']}
            />
        </div>
    );
};

export default InvoiceView;
